module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-completion","title":"文本填空","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-completion/package.json
// module id = 212
// module chunks = 0